import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { Logger } from '@app/core/logger.service';
import { AppService } from '@app/services';
import { ConfigurationsAppearanceComponent } from '@app/pages/configurations/configurations-appearance/configurations-appearance.component';

const log = new Logger('NoWhitelabelAccessGuard');

@Injectable({
  providedIn: 'root'
})
export class NoWhitelabelAccessGuard implements CanActivate {
  constructor(private router: Router, private appService: AppService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (!this.appService.isAutentiqueDomain()) {
      log.debug('This route was forbidden in whitelabel, redirecting...');

      if (route.component === ConfigurationsAppearanceComponent) {
        this.router.navigate(['/perfil/emails'], { replaceUrl: true });
      } else {
        this.router.navigate(['/404'], { replaceUrl: true });
      }

      return of(false);
    }

    return of(true);
  }
}
